<template>
  <div class="ccui-app-iframe-no-operate-container">
    <breadcrumbSourcing :breadcrumb-data="breadcrumbData"></breadcrumbSourcing>
    <div class="ccui-app-iframe-container-no-operate-detail">
      <div class="ccui-app-iframe-container-detail-body">
        <div class="ccui-tab-iframe">
          <div class="ccui-tab-wrapper">
            <el-button
              :key="item.active"
              v-for="item in tabList"
              :type="
                activeName == item.active ? 'table-top-active' : 'table-top'
              "
              size="mini"
              @click="activeName = item.active"
              >{{ item.name }}</el-button
            >
          </div>
        </div>
        <template v-if="activeName == '1'">
          <el-form :model="form" ref="form" label-width="120px">
            <el-row>
              <el-col :span="12">
                <el-form-item
                  :label="
                    `${
                      purchaseType == 1 ||
                      purchaseType == 4 ||
                      purchaseType == 7 ||
                      purchaseType == 8
                        ? '评审'
                        : '评标'
                    }室：`
                  "
                >
                  <span>{{ form.evaRoomName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :label="
                    `预计总${
                      purchaseType == 1 ||
                      purchaseType == 4 ||
                      purchaseType == 7 ||
                      purchaseType == 8
                        ? '评审'
                        : '评标'
                    }时间：`
                  "
                >
                  <span>{{ form.hadTime }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item
                  :label="
                    `${
                      purchaseType == 1 ||
                      purchaseType == 4 ||
                      purchaseType == 7 ||
                      purchaseType == 8
                        ? '评审'
                        : '评标'
                    }时间：`
                  "
                >
                  <span>{{ form.evaTime }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :label="
                    `${
                      purchaseType == 1 ||
                      purchaseType == 4 ||
                      purchaseType == 7 ||
                      purchaseType == 8
                        ? '评审'
                        : '评标'
                    }办法：`
                  "
                >
                  <span>{{ form.evaMethodStr }}</span>
                  <!-- <span>{{ form.evaMethodStrAndEvaFormStr }}</span> -->
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <div class="ccui-tab-iframe">
            <div class="ccui-tab-wrapper">
              <el-button type="table-top-active" size="mini">{{
                `${
                  purchaseType == 1 ||
                  purchaseType == 4 ||
                  purchaseType == 7 ||
                  purchaseType == 8
                    ? "评审"
                    : "评标"
                }专家`
              }}</el-button>
            </div>
          </div>
          <el-table :data="expertData" border>
            <el-table-column
              type="index"
              width="50"
              label="序号"
            ></el-table-column>
            <el-table-column
              property="expertSourceStr"
              label="专家来源"
              show-overflow-tooltip
              width="130"
            >
              <template slot-scope="{ row }">
                {{ row.expertSourceStr }}
                <!-- {{ row.expertSource == "0" ? "随机抽取" : "单位委派" }} -->
              </template>
            </el-table-column>
            <el-table-column
              property="expertName"
              label="专家姓名"
              show-overflow-tooltip
              width="130"
            ></el-table-column>
            <el-table-column
              property="expertRoleStr"
              label="专家角色"
              show-overflow-tooltip
              width="100"
            >
              <template slot-scope="{ row }">
                {{ row.expertRole == "0" ? "组员" : "组长" }}
              </template>
            </el-table-column>
            <!--<el-table-column
              property="professional"
              label="评标专业"
              show-overflow-tooltip
              width="130"
            ></el-table-column>-->
            <el-table-column
              property="workUnitName"
              label="工作单位"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              property="signFlag"
              label="签到情况"
              show-overflow-tooltip
              width="130"
            ></el-table-column>
            <el-table-column
              property="signTime"
              label="签到时间"
              show-overflow-tooltip
              width="170"
            ></el-table-column>
          </el-table>
        </template>
        <template v-if="activeName == '2'">
          <el-table :data="fileData" border>
            <el-table-column
              type="index"
              width="50"
              label="序号"
            ></el-table-column>
            <el-table-column
              property="uploadPhaseStr"
              label="环节名称"
              show-overflow-tooltip
              width="130"
            >
              <template slot-scope="{ row }">
                <span>{{ row.uploadPhaseStr }}</span>
              </template>
            </el-table-column>
            <el-table-column
              property="fileName"
              label="附件名称"
              show-overflow-tooltip
              width="130"
            ></el-table-column>
            <el-table-column
              property="fileSize"
              label="附件大小"
              show-overflow-tooltip
              width="130"
            >
              <template slot-scope="{ row }">
                <span>{{ row.fileSize }}K</span>
              </template>
            </el-table-column>
            <el-table-column
              property="fileSumm"
              label="附件说明"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="操作" width="80">
              <template slot-scope="{ row }">
                <el-button type="text" @click="download(row)">下载</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import breadcrumbSourcing from "@/app/subSourcingFlow/components/breadcrumb-sourcing.vue";
import {
  scpQryBidEvaPrepareDetailApi,
  scpQryJoinExpertListApi,
  scpQryFileinfoListApi
} from "@/app/sourcingFlow/api/scp-expertEvaluation.js";
import { addUrlPerFix } from "@/basa/utils";
import moment from "moment";

export default {
  name: "sourcingFlow",
  components: {
    breadcrumbSourcing
  },
  data() {
    return {
      purchaseType: JSON.parse(sessionStorage.getItem("expertSourceData"))
        .purchaseType,
      labelType:
        JSON.parse(sessionStorage.getItem("expertSourceData")).evaStatus === "2"
          ? "evaluation"
          : JSON.parse(sessionStorage.getItem("expertSourceData")).evaStatus ===
            "3"
          ? "evaluationEnds"
          : "evaluationEnds", // 评标中：evaluation 评标结束：evaluationEnds
      breadcrumbData: {
        titname: "专家评标",
        status: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .evaStatusStr
      },
      activeName: "1",
      form: {
        hadTime: "00天 00小时 00分钟"
      },
      fileData: [],
      expertData: [],
      tabList: [
        {
          name: "评标项目",
          active: "1"
        },
        {
          name: "相关附件",
          active: "2"
        }
      ],
      moment: moment
    };
  },
  watch: {
    purchaseType: {
      handler(newVal) {
        if (newVal == 1 || newVal == 4 || newVal == 7 || newVal == 8) {
          this.breadcrumbData.titname = "专家评审";
          this.tabList.forEach(item => {
            if (item.active == "1") {
              item.name = "评审项目";
            }
          });
        } else {
          this.breadcrumbData.titname = "专家评标";
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    console.log("是分包呀！！");
    this.getData();
  },
  methods: {
    getData() {
      scpQryBidEvaPrepareDetailApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        bidEvaId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .bidEvaId
      }).then(res => {
        this.form = res.data.data;
        this.getHadTime(this.form.evaStartTime, this.form.evaEndTime);
        sessionStorage.setItem(
          "bidEvaPrepareDetailData",
          JSON.stringify(this.form)
        );
        scpQryFileinfoListApi({
          parentBillId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          // billId: this.form.bidEvaId,
          // billType: "0800",
          uploadPhases: ["102", "0800", "0203", "0301", "14"]
        }).then(res => {
          this.fileData = res.data.data;
        });
      });
      scpQryJoinExpertListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        evaPurStep: this.$router.history.current.query.evaPurStep,
        bidEvaId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .bidEvaId
      }).then(res => {
        this.expertData = res.data.data.rows;
      });
    },
    getHadTime(startTime, endTime) {
      if (startTime && endTime) {
        let start = startTime;
        let end = endTime;
        start = start.split("-").join("/");
        end = end.split("-").join("/");
        let time = new Date(end).getTime() - new Date(start).getTime();
        let date = parseInt(time / (24 * 60 * 60 * 1000));
        let hadTime;
        let hours;
        let minutes;
        (!date || date < 0) && (date = 0);
        hours = parseInt(
          (time - date * (24 * 60 * 60 * 1000)) / (60 * 60 * 1000)
        );
        (!hours || hours < 0) && (hours = 0);
        minutes = parseInt(
          (time - date * (24 * 60 * 60 * 1000) - hours * (60 * 60 * 1000)) /
            (60 * 1000)
        );
        (!minutes || minutes < 0) && (minutes = 0);
        date < 10 && (date = "0" + date);
        hours < 10 && (hours = "0" + hours);
        minutes < 10 && (minutes = "0" + minutes);
        hadTime = date + "天 " + hours + "小时 " + minutes + "分钟";
        this.form.hadTime = hadTime;
      }
    },
    download(row) {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/bid-scp/oss/downloadByUploadId?uploadId=${row.uploadId}`;
      openUrl.setAttribute("download", row.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .el-table td {
  height: 36px !important;
  line-height: 36px !important;
}
</style>
<style>
.ccui-top-bar-wrapper {
  display: none;
}
.evaTimeTip {
  color: #ff142f;
  position: absolute;
  left: 138px;
  top: 0;
  padding-top: 6px;
  line-height: 18px;
}
</style>
